
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hr-as-a-service",
      function () {
        return require("private-next-pages/hr-as-a-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hr-as-a-service"])
      });
    }
  